import { OPEN_MENU, CLOSE_MENU, CLOSE_ALL_MENUS } from '../actions/types';

const initialState = {
	openMenus: []
};

const menuReducer = (state = initialState, action) => {
	switch (action.type) {
		case OPEN_MENU:
			return {
				...state,
				openMenus: [...state.openMenus, action.menuItemId]
			};
		case CLOSE_MENU:
			return {
				...state,
				openMenus: state.openMenus.filter(
					(id) => id !== action.menuItemId
				)
			};

		case CLOSE_ALL_MENUS:
			return {
				...state,
				openMenus: []
			};
		default:
			return state;
	}
};

export default menuReducer;
